import { ChangeDetectionStrategy, Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { MobileService, SideNaveActionsTypes, SideNaveDataTypes } from '@klickdata/core/mobile';
import { ResourceOpportunity } from '@klickdata/core/opportunity';
import { Resource, ResourceTypes } from '@klickdata/core/resource';
import { ResourceItem } from '@klickdata/core/resource-item';
import { User } from '@klickdata/core/user';
import { OccasionService } from '@klickdata/player/src/core/occasion/occasion.service';
import { ResourceItemOpportunityService } from '@klickdata/player/src/core/resource-item/resource-item.service';
import { OnDestroyHandler } from 'apps/klickdata/src/app/shared/onDestroy-handler/onDestroy-handler';
import { Observable, filter, takeUntil } from 'rxjs';
import { Router } from '@angular/router';
import { Utils } from '@klickdata/core/util';

@Component({
    selector: 'app-activity-scorm-expansion-info',
    templateUrl: './activity-scorm-expansion-info.component.html',
    styleUrls: ['./activity-scorm-expansion-info.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ActivityScormExpansionInfoComponent extends OnDestroyHandler implements OnChanges {
    @Input() occasionId: number;
    @Input() user: User;
    @Input() resource: Resource;
    public parentOpp$: Observable<ResourceOpportunity>;
    public items$: Observable<ResourceItem[]>;
    ResourceTypes = ResourceTypes;
    Utils = Utils;
    constructor(
        protected resourceItemService: ResourceItemOpportunityService,
        protected occasionService: OccasionService,
        protected mobile: MobileService,
        protected router: Router
    ) {
        super();
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (!this.items$ && this.occasionId) {
            this.items$ = this.resourceItemService.getAllItems(this.resource.id, this.occasionId);
        }
        if (!this.parentOpp$ && this.occasionId) {
            this.parentOpp$ = this.occasionService.getOccasion(this.occasionId);
        }
    }

    public repeatItem(item: ResourceItem) {
        this.mobile.updateSideNavSub({
            dataType: SideNaveDataTypes.GENERAL_NOTIFIER,
            data: {
                icon: 'play_circle_outline',
                title: $localize`Study again`,
                contentBody: item.item_opportunity_started_at
                    ? $localize`Do you want to repeat this part?`
                    : $localize`Do you want to start this part?`,
                positiveBtn: item.item_opportunity_started_at ? $localize`Repeat` : $localize`Start`,
                negativeBtn: $localize`Cancel`,
            },
        });
        this.mobile
            .getSideNavAction()
            .pipe(
                takeUntil(this.destroy),
                filter((action) => action == SideNaveActionsTypes.POSITIVE)
            )
            .subscribe(() => {
                const queryParams = {
                    referrer: '/home/dashboard/main',
                    ...(item && { position: item.entry_url }),
                };

                this.router.navigate(['/player/resource', this.resource.id, 'scorm'], {
                    queryParams,
                });
            });
    }
}
